import React from 'react';
import {t} from '@lingui/core/macro';

import Logo from 'shared/ui/icons/General/Logo';
import LogoEn from 'shared/ui/icons/General/LogoEn';
import {isTranslate} from 'shared/lib/lang';

import styles from './SummaryHeader.module.scss';

const SummaryHeader: React.FC = () => (
    <header className={styles.header}>
        <div className={styles.container}>
            <a className={styles.logo} href="/" aria-label={t`На главную`}>
                {
                    !isTranslate() ? <Logo /> : <LogoEn />
                }
            </a>
        </div>
    </header>
);

export default SummaryHeader;